// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Article_wrapper__7ikSf","metadata":"Article_metadata__OoBn5","article":"Article_article__KxIRI","value":"Article_value__bqabz","copy":"Article_copy__vwKeR"};